import React, { useState, useMemo, useEffect } from 'react'
import { Formik } from 'formik'
import utils from './utils'
import Validate from './validate'

const MountedForm = ({
  handleSubmit,
  isValid,
  values,
  errors,
  touched,
  children,
  onChange,
}) => {
  const [ showErrors, setShowErrors ] = useState(false)

  const submitWrapper = (mode) => {
    setShowErrors(true)
    handleSubmit(mode)
  }

  useEffect(() => {
    if(onChange) onChange(values)
  }, [
    values,
  ])

  return (
    <div>
      {
        children({
          isValid,
          values,
          errors,
          showErrors,
          touched,
          onSubmit: submitWrapper,
        })
      }
    </div>
  )
}

const FormWrapper = ({
  schema,
  initialValues,
  validationSchema,
  handlers = {},
  children = () => {},
  onSubmit,
  onChange,
}) => {

  const useValidationSchema = useMemo(() => validationSchema || Validate(schema), [schema, validationSchema])
  const useInitialValues = useMemo(() => utils.getInitialValues(schema, initialValues), [schema, initialValues])

  return (
    <Formik
      initialValues={ useInitialValues }
      validationSchema={ useValidationSchema }
      validateOnMount
      validate={ handlers.validate }
      onSubmit={ onSubmit }
    >
      {
        ({
          handleSubmit,
          isValid,
          values,
          errors,
          touched,
        }) => {
          return (
            <MountedForm
              handleSubmit={ handleSubmit }
              onChange={ onChange }
              isValid={ isValid }
              values={ values }
              errors={ errors }
              touched={ touched }
            >
              { children }
            </MountedForm>
          )
        }
      }
    </Formik>
  )
}

export default FormWrapper